import { render } from "./Logo.vue?vue&type=template&id=4225564f"
const script = {}

import exportComponent from "/home/christian/dev/pingcrm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__